export const getProcessIndicators = state => state.entries.processIndicator

export const isProcessInProgress = (state, name) => !!(state.entries.processIndicator[name] || {}).isRunning

export const getProcessUpdateTime = (state, name) => (state.entries.processIndicator[name] || {}).updateTime
